import React from 'react';
import { DownloadIcon, ShieldCheckIcon } from 'lucide-react';
import { OfferEndedButton } from './OfferEndedButton';
import { useOfferTimer } from '../../contexts/OfferTimerContext';
const closingCopy = {
  eyebrow: '🎀 Un día especial merece recuerdos especiales',
  title: 'Que el mejor recuerdo sea lo lindo que la pasaron… no las horas que pasaste organizando.',
  text: 'Los juegos ya están preparados. Solo tenés que elegir tus favoritos, organizar las actividades y disfrutar de ese momento tan esperado junto a las personas que querés.',
  cta: 'Quiero mi kit completo →'
};
const trustItems: {
  label: string;
  icon: React.ReactNode;
}[] = [{
  label: 'Producto digital',
  icon: <DownloadIcon className="h-3.5 w-3.5 text-[#9A7A60]" strokeWidth={2} aria-hidden="true" data-id="element-61" data-mp="3upu0z2m3e2ld" />
}, {
  label: 'Versiones rosa y celeste incluidas',
  icon: <span className="flex gap-0.5" aria-hidden="true" data-id="element-62" data-mp="1xws72rm5ob94">
        <span className="h-2 w-2 rounded-full bg-[#F5B4C9]" data-id="element-63" data-mp="1sxp73ll18v80" />
        <span className="h-2 w-2 rounded-full bg-[#93D1CE]" data-id="element-64" data-mp="1swe6fumvw3l4" />
      </span>
}, {
  label: 'Garantía de 7 días',
  icon: <ShieldCheckIcon className="h-3.5 w-3.5 text-[#E74D7A]" strokeWidth={2} aria-hidden="true" data-id="element-65" data-mp="ocs01emfeo99" />
}];
export function ClosingCta() {
  const {
    expired
  } = useOfferTimer();
  return <section aria-labelledby="closing-title" className="bg-[#FBF6EE] px-4 pb-10 pt-2 md:px-6 md:pb-14" data-id="element-66" data-mp="af3dm2cpn923">
      <div className="mx-auto max-w-3xl rounded-[2rem] border border-[#F5B4C9] bg-[#FEEAF1] px-5 py-9 text-center sm:px-10 md:py-12" data-id="element-67" data-mp="fe69aw6sw2xe">
        <div className="flex justify-center gap-1.5" aria-hidden="true" data-id="element-68" data-mp="18193jc4g1rhu">
          <span className="h-1.5 w-1.5 rounded-full bg-[#93D1CE]" data-id="element-69" data-mp="182k9nild3bc4" />
          <span className="h-1.5 w-6 rounded-full bg-[#F5B4C9]" data-id="element-70" data-mp="tbbk19hglpyz" />
          <span className="h-1.5 w-1.5 rounded-full bg-[#93D1CE]" data-id="element-71" data-mp="ya60w5vv94gg" />
        </div>

        <p className="mt-4 inline-flex max-w-full items-center rounded-full border border-[#F5B4C9] bg-white px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.08em] text-[#8B6B55] sm:text-[12px]" data-id="element-72" data-mp="1m0s9pzdp2sri">
          {closingCopy.eyebrow}
        </p>

        <h2 id="closing-title" className="mx-auto mt-4 max-w-[26ch] font-serif text-[1.6rem] font-semibold italic leading-[1.2] text-[#4A3A35] [text-wrap:balance] sm:text-[2rem] md:text-[2.25rem]" data-id="element-73" data-mp="20mfwztf72del">
          {closingCopy.title}
        </h2>

        <p className="mx-auto mt-4 max-w-lg text-[16px] leading-relaxed text-body md:text-[17px]" data-id="element-74" data-mp="1mnpxy88te3nl">{closingCopy.text}</p>

        <div className="mx-auto mt-7 max-w-md" data-id="element-75" data-mp="1homqkh5d3lcg">
          {expired ? <OfferEndedButton data-id="element-76" data-mp="1hq6coodp8qm5" /> : <a href="#ajanlat" className="flex w-full items-center justify-center rounded-full bg-gradient-to-r from-[#E74D7A] to-[#EC6A92] px-6 py-4 text-center font-display text-[17px] font-extrabold uppercase leading-snug tracking-tight text-white shadow-[0_14px_30px_-12px_rgba(231,77,122,0.65)] transition-transform duration-150 ease-out hover:scale-[1.01] hover:from-[#DE3F6E] hover:to-[#E74D7A] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E74D7A] focus-visible:ring-offset-2 focus-visible:ring-offset-[#FEEAF1] active:scale-[0.98] sm:py-5 sm:text-xl" data-id="element-77" data-mp="1cx4rjymwfuu4">
            {closingCopy.cta}
          </a>}
        </div>

        <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-78" data-mp="3ajw2q1px7r1i">
          {trustItems.map(item => <li key={item.label} className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-white/80 px-3 py-1.5 text-[13px] font-semibold text-[#4A3A35]" data-id="element-79" data-mp="3enviuj7agnuc">
              {item.icon}
              {item.label}
            </li>)}
        </ul>
      </div>
    </section>;
}